import React from "react";
import { motion } from "framer-motion";
import { CheckIcon } from "lucide-react";
import { Reveal } from "../ui/Reveal";
import { SectionTitle } from "../ui/SectionTitle";
import { lifestyle } from "../../data/images";
import { EASE_OUT } from "../../utils/motion";
const timeline = [{
  time: "4:00 PM",
  text: "Tu hija llega del colegio pidiendo algo dulce."
}, {
  time: "4:01 PM",
  text: "Abres el Pack Dulce Saludable en tu celular y eliges entre 100+ recetas ya probadas."
}, {
  time: "4:15 PM",
  text: "Pasas 15 minutos en la cocina. Sin ingredientes raros."
}, {
  time: "4:35 PM",
  text: "Están comiendo algo delicioso. Y tú también."
}];
const benefits = ["Sabe EXACTAMENTE como un postre \"de verdad\"", "No los va a dejar hiperactivos", "No va a generar malestar digestivo", "Es tan fácil que ni siquiera tienes que pensar"];
export function ImagineSection() {
  return <section className="bg-white py-20 lg:py-28" data-id="element-226" data-mp="2ij3qmccvvydd">
      <div className="mx-auto max-w-6xl px-5" data-id="element-227" data-mp="2ikn4jwb2hxbz">
        <SectionTitle intro="Imagina esto:" data-id="element-228" data-mp="3r63ee1xz3wlr">No Es "Un Recetario". Es Tu Nuevo Sistema de Vida Dulce</SectionTitle>

        <ol className="relative mt-14 grid gap-8 md:grid-cols-4 md:gap-6" data-id="element-229" data-mp="3w3c0ueq5mmst">
          <motion.span aria-hidden className="absolute left-[7%] right-[7%] top-6 hidden h-0.5 origin-left bg-blush-dark md:block" initial={{
          scaleX: 0
        }} whileInView={{
          scaleX: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: EASE_OUT
        }} data-id="element-230" data-mp="402py1b9gki9" />
          {timeline.map((t, i) => <Reveal key={t.time} delay={i * 0.08} className="relative flex gap-4 md:flex-col md:items-center md:text-center" data-id="element-231" data-mp="3hfh48n90zyag" data-mpi={i}>
              <span className={`relative z-10 flex h-12 shrink-0 items-center justify-center rounded-full px-4 font-display text-sm font-bold shadow-md ${i === timeline.length - 1 ? "bg-berry text-white" : "bg-cocoa text-cream"}`} data-id="element-232" data-mp="3m6h15si5agcy">
                {t.time}
              </span>
              <p className="pt-2.5 text-cocoa-light md:pt-4" data-id="element-233" data-mp="tlc5rgxj22i">{t.text}</p>
            </Reveal>)}
        </ol>

        <div className="mt-20 grid items-center gap-12 lg:grid-cols-2" data-id="element-234" data-mp="3rzwers1l8avy">
          <Reveal x={-24} y={0} data-id="element-235" data-mp="9n7yys35suzk">
            <img src={lifestyle.kids} alt="Madre e hijos comiendo muffins y galletas saludables después del colegio" className="aspect-[4/3] w-full rounded-[2rem] object-cover shadow-[0_30px_60px_-25px_rgba(59,34,25,0.5)] ring-8 ring-blush-light" data-id="element-236" data-mp="5m4lgc8l3b1i" />
          </Reveal>
          <div data-id="element-237" data-mp="3n35rokrd8f11">
            <Reveal data-id="element-238" data-mp="3n3p6vtpmspbd">
              <p className="text-lg font-semibold text-cocoa" data-id="element-239" data-mp="3n47chgy6ofvy">20 minutos después, están comiendo algo que:</p>
            </Reveal>
            <ul className="mt-6 space-y-4" data-id="element-240" data-mp="3i5w0p0obvvb3">
              {benefits.map((b, i) => <Reveal key={b} delay={i * 0.05} data-id="element-241" data-mp="12ehz78d4p25d" data-mpi={i}>
                  <li className="flex items-start gap-3 text-lg text-cocoa" data-id="element-242" data-mp="xe3t3vv3829z">
                    <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-leaf text-white" data-id="element-243" data-mp="15uksz3cmtxba">
                      <CheckIcon className="h-4 w-4" strokeWidth={3} data-id="element-244" data-mp="19wza9j0nkp0g" />
                    </span>
                    {b}
                  </li>
                </Reveal>)}
            </ul>
            <Reveal delay={0.2} className="mt-8 rounded-2xl bg-blush-light p-6" data-id="element-245" data-mp="10wax0qj32som">
              <p className="text-lg leading-relaxed text-cocoa-light" data-id="element-246" data-mp="1okkexhd6ewah">
                Y aquí está la mejor parte: <b className="text-cocoa" data-id="element-247" data-mp="1tk6sjrwx2ejt">tú también comes un pedazo.</b> Y te sientes bien. De verdad bien.{" "}
                <span className="font-script text-2xl text-berry" data-id="element-248" data-mp="1etzle8cd0hyf">Sin culpa.</span>
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>;
}